// Helper functions for analytics integration
import { getFunctions, httpsCallable } from 'firebase/functions';

const functions = getFunctions();
const getUserInfoForAnalytics = httpsCallable(functions, 'getUserInfoForAnalytics');

/**
 * Get user email and business name by UID for analytics tracking
 * @param userId - Firebase UID of the user
 * @returns Object with email and businessName
 */
export const getUserInfoByUID = async (userId: string): Promise<{email: string | null, businessName: string | null}> => {
  try {
    const result = await getUserInfoForAnalytics({ userId });
    const data = result.data as { email: string | null, businessName: string | null };
    return data;
  } catch (error) {
    console.error('Error fetching user info:', error);
    return { email: null, businessName: null };
  }
};

/**
 * Get current user info from Redux store
 * This is a helper to be used with the actual Redux selectors
 */
export const getCurrentUserInfo = (state: any) => {
  const user = state?.auth?.currentUser || state?.user;
  const businessAccount = state?.account?.activeAccount;
  
  return {
    user: user,
    businessAccount: businessAccount,
    email: user?.protected?.email || user?.email,
    businessName: businessAccount?.business_name || businessAccount?.name
  };
};

/**
 * Format business name for GA4 User ID
 * @param businessName - Raw business name
 * @returns Formatted business name (lowercase, underscores for spaces)
 */
export const formatBusinessNameForGA4 = (businessName: string): string => {
  return businessName
    .toLowerCase()
    .replace(/\s+/g, '_')
    .replace(/[^a-z0-9_]/g, '');
};